<template>
    <el-container>
        <!-- 头部 -->
        <el-header class="header inner" style="height: 1rem;">
            <dashboard-header :headList="headList"></dashboard-header>
        </el-header>
        <!-- 导航条 -->
        <div class="fullDiv">
            <div class="inner">
                <ul class="flexRow">
                    <li class="navLi" :class="{navLiSelect: changedNav==index}" @click="handleClickNav(index)" v-for="(item, index) of List" :key="index">{{item.title}}</li>
                </ul>
            </div>
        </div>
        <!-- 中间内容 -->
        <el-main class="inner">
            <h1>404,找不到页面</h1>
        </el-main>
        <el-footer class="footerSty" style="height: 0.3rem;">
            <footers></footers>
        </el-footer>
    </el-container>
</template>

<script>
import DashboardHeader from '../ivew/header'
import Footers from '../ivew/footer'
import { setTokenKey, jump } from '../../untils/auth'
export default {
    name: 'Dashboard',
    data() {
        return {
            List: [
                {
                    title: '首页',
                    path: '/dashboard'
                }
            ],
            changedNav: 0,
            headList: {
                imgUrl: require('../../assets/images/logo.png'),
                subtitle: '知识成就未来',
                List: [
                    {
                        title: '购物车',
                        path: ''
                    },
                    {
                        title: '我的消息',
                        path: ''
                    },
                    {
                        title: '我的订单',
                        path: ''
                    },
                    {
                        title: '用户中心',
                        path: ''
                    }
                ]
            }
        }
    },
    components: {
        DashboardHeader,
        Footers
    },
    beforeRouteEnter(to, from, next) {
        setTokenKey('url',to.path);
        next()
    },
    methods: {
        jump,
        handleClickNav(idx) {
            this.changedNav = idx;
            this.jump(this.List[idx].path)
        }
    }
}
</script>

<style>
    .flexRow {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .fullDiv .flexRow {
        justify-content: left;
    }
    .flexRow li {
        height: 100%;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 100px;
        margin-left: 49px;
    }
    .flexRow li.navLi {
        width: 180px;
        height: 60px;
        line-height: 60px;
        background: #228457;
        text-align: center;
        color: #fff;
        font-size: 22px;
        cursor: pointer;
        margin-left: 0px;
    }
    .flexRow li.navLi.navLiSelect {
        border-top: 1px solid #228457;
        border-bottom: 1px solid #228457;
        background: #f8f8f8;
        color: #228457;
    }
</style>



// WEBPACK FOOTER //
// src/components/404/404.vue